import { useParams } from "react-router-dom";
import { WBCButton } from "@wbc/ui";

import wbcLogo from "../assets/wbc-logo.svg";
import { buildLinks } from "../lib/links.js";

const SplashPage = () => {
  // https://www.splash/MID  ->  mid === "MID"
  const { mid } = useParams();
  const links = buildLinks(mid);

  return (
    <main className="splash">
      <div className="splash__panel">
        <img className="splash__logo" src={wbcLogo} alt="WeBuyCars" width={76} height={65} />

        <h1 className="splash__heading">
          Click your
          <br />
          next
        </h1>

        <p className="splash__subheading">
          Quick. Easy. Simple. Sell your car today with immediate payment.
        </p>

        <nav className="splash__actions" aria-label="WeBuyCars quick links">
          <div className="splash__actions-pair">
            <WBCButton
              color="primary"
              variant="contained"
              fullWidth
              href={links.sellMyCar}
            >
              Sell my car
            </WBCButton>

            <WBCButton
              color="primary"
              variant="contained"
              fullWidth
              href={links.buyACar}
            >
              Buy a car
            </WBCButton>
          </div>

          <WBCButton
            color="white"
            variant="outlined"
            fullWidth
            href={links.rateUs}
          >
            Rate our service
          </WBCButton>
        </nav>

        <p className="splash__footnote">You&rsquo;re connected to We Buy Cars WiFi</p>
      </div>
    </main>
  );
};

export default SplashPage;
